export function getSongKeyVal(keyVal: string) {
  const keys = keyVal.split("_");
  const result: string[] = [];
  for (let i = 0; i < keys.length; i += 2) {
    const combinedKey = keys[i] + (keys[i + 1] ? "_" + keys[i + 1] : "");
    result.push(getSongKeyValForSingleCase(combinedKey));
  }
  return result.join("/");
}

function getSongKeyValForSingleCase(keyVal: string) {
  let str = keyVal.split("_")[0];
  str = str.charAt(0).toUpperCase() + str.slice(1);
  if (keyVal.includes("flat")) {
    str += "♭";
  }
  if (keyVal.includes("sharp")) {
    str += "♯";
  }
  return str;
}
